import Marquee from "react-fast-marquee";
import { Phone, AlertTriangle } from "lucide-react";
import { useSiteContent, phoneHref } from "@/lib/siteContent";

export default function EmergencyBanner() {
  const { banner_text, owners, business } = useSiteContent();
  const items = [banner_text, `TAP TO CALL: ${owners[1].phone}`, "LICENSED • BONDED • INSURED", `PROUDLY SERVING ${business.region.toUpperCase()}`];
  return (
    <a
      href={phoneHref(owners[1].phone)}
      data-testid="emergency-banner"
      className="block bg-red-600 hover:bg-red-500 transition-colors duration-300 py-2 relative z-40"
    >
      <Marquee speed={55} gradient={false} pauseOnHover>
        {items.map((text, i) => (
          <span
            key={i}
            className="flex items-center gap-3 mx-8 font-bebas text-lg tracking-[0.2em] text-white"
          >
            {i % 2 === 0 ? (
              <AlertTriangle className="w-4 h-4 shrink-0" />
            ) : (
              <Phone className="w-4 h-4 shrink-0" />
            )}
            {text}
          </span>
        ))}
      </Marquee>
    </a>
  );
}
